export default {
  Title: "Access log",
  UserUsing: "User",
  Time: "Time",
  Action: "Action",
  Reference: "References",
  Description: "Description",
  IPAddress: "IP Address",
  Organization: "Branches, departments",
  Filter: "Filter",
  DateFilter: "Period",
  SearchFilter: "Enter the user, reference, description, IP address to search",
  OrgStructure: "Organizational structure",
  ActionDetail: "Action details",
};
